import { render, staticRenderFns } from "./HeroCarouselDerModule.vue?vue&type=template&id=23a1c2d7&"
import script from "./HeroCarouselDerModule.ts?vue&type=script&lang=ts&"
export * from "./HeroCarouselDerModule.ts?vue&type=script&lang=ts&"
import style0 from "./HeroCarouselDerModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports